import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import styled from 'styled-components';

import Spinner from "react-spinners/PuffLoader";

import { getRazorpayOrder } from "../../services/backendHelpers";
import {analytics } from '../../services/eventTracker';

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    
    height: 100vh;
    flex-direction: column;
    padding: 16px;
    background: rgba(14, 15, 24, 1);
`;



const RazorpayBuyBtxComponent = (props:any)=> {
    const [isLoading, setIsLoading] = useState(false);
    const navigate: any = useNavigate();
    
    const goBack = () => {
        (window as any).close();
    };

    const initializeRazorpay = ({orderId, amount, btxAmount, userId, allOptions }:any)=>{
        const startTime = new Date(); // Capture the start time
        console.log(orderId, amount, btxAmount, userId);
        analytics.identify(userId);
       // let upiConfig:any = {
       //     display: {
       //         blocks: {
       //             banks: {
       //                 name: 'Pay via UPI',
       //                 instruments: [
       //                     {
       //                         method: 'upi'
       //                     }
       //                 ],
       //             },
       //         },
       //         sequence: ['block.banks'],
       //         preferences: {
       //             show_default_blocks: false,
       //         },
       //     },
       // };
       // if(allOptions){
       //     upiConfig = undefined;
       // }

	let upiConfig:any = {
		display: {
			preferences:{
				show_default_blocks: true
			}
		}
	}	

        var options = {
                "key": "rzp_live_a3uMSIHYCiYVgE",
                "amount": amount,
                "currency": "INR",
                "name": "AimLock", //your business name
                "description": "Buying AimLock Assets",
		"webview_intent": true,
		"method": "upi",
                "image": "https://cdn-m.namasteapis.com/crypto/btx/aimlock2.png",
                "order_id": orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                "handler": function (response:any){
                console.log('going back');
                const endTime = new Date(); // Capture the end time
                const processingTime = endTime.getTime() - startTime.getTime(); 
                //analytics.track("succeeded_buy_gc", {
                //    "btx_amount": btxAmount,
                //    "inr_amount": amount,
                //    "processing_time": processingTime
                //});
                (window as any).alert('closeActivity')
                (window as any).close();
            },
            "prefill": {
                
            },
            "notes": {
                "address": "Razorpay Corporate Office"
            },
            "theme": {
                "color": "#000000",
                "hide_topbar": true
            },
            "modal":{
                "ondismiss": ()=>{(window as any).alert('closeActivity')}
            },
            "config": upiConfig
        };
        var rzp1 = new (window as any).Razorpay(options);
        rzp1.on('payment.failed', function (response:any){
            analytics.track("failed_buy_gc", {
                "btx_amount": btxAmount,
                "inr_amount": amount,
                "failure_reason": response.error.reason,
                "payment_gateway": response.error.source
            });
        });
        rzp1.open();
        setIsLoading(false);
    }

    const startRazorpayOrder = async ()=>{
	const urlParams = new URLSearchParams(window.location.search);
        const productId = urlParams.get('productId');
	const paymentFor = urlParams.get('payment_for');
        const allOptions = urlParams.get('allOptions');
        if (!productId) {
            console.error('No product ID found in URL');
            return false;
        }
        
        let rzpOrderId = await getRazorpayOrder({productId, payment_for: paymentFor});
        if(!rzpOrderId){
            return false;
        }
        
        initializeRazorpay({orderId: rzpOrderId.id, amount: rzpOrderId.amount,
                            btxAmount:rzpOrderId.notes.btxAmount,
                            userId: rzpOrderId.notes.userId,
                            allOptions
        });
    }
    
    useEffect(()=>{
        startRazorpayOrder();
    },[])
    
    if (isLoading) {
        // Show spinner while data is loading
        return (
            <Container>
              <div style={{
                  marginTop: 28,
                  display:'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
              }}>
                <Spinner  color="#ffffff" />
              </div>
            </Container>
        );
    }
    return (
        <Container>
        </Container>
    );
}
export default RazorpayBuyBtxComponent;
